import { observer } from 'mobx-react-lite'
import { BugAntIcon } from '@heroicons/react/24/outline'
import { Reducer, useReducer, useState } from 'react'

import { env } from '@/env'

import { DebugButton } from './DebugButton'
import { DebugCheckbox } from './DebugCheckbox'
import { DebugOptionsType, loadDebugOptions } from './loadDebugOptions'

export const DebugOptions = observer(() => {
    const [open, setOpen] = useState(false)

    const [debugOptions, updateDebugOptions] = useReducer<Reducer<DebugOptionsType, Partial<DebugOptionsType>>>(
        (state, updatedOptions) => {
            const newState = { ...state, ...updatedOptions }
            localStorage.setItem('debug:options', JSON.stringify(newState))
            return newState
        },
        loadDebugOptions()
    )

    return (
        <>
            {open && (
                <div className="absolute bottom-full right-0 h-96 w-60 overflow-auto rounded-lg border border-neutral-300 bg-white p-2 shadow-lg dark:border-neutral-700 dark:bg-neutral-900">
                    <div className="flex h-full flex-col gap-2">
                        <DebugCheckbox
                            label="Log TRPC calls"
                            checked={debugOptions.logTRPCCalls || false}
                            onToggle={(checked) => {
                                updateDebugOptions({ logTRPCCalls: checked })
                            }}
                        />
                        <DebugCheckbox
                            label="Hide Upcoming Features"
                            checked={debugOptions.hideUpcomingFeatures || false}
                            onToggle={(checked) => {
                                updateDebugOptions({ hideUpcomingFeatures: checked })
                                location.reload()
                            }}
                        />

                        <div className="flex-1" />
                        <button
                            className="rounded bg-red-500 py-1 text-xs font-medium text-white hover:bg-red-700"
                            onClick={() => {
                                throw new Error('This is a test error')
                            }}
                        >
                            Throw an error
                        </button>
                        {env.VITE_PRODUCT_RELEASE && (
                            <div className="text-xs text-white">
                                SHA: {`${env.VITE_PRODUCT_RELEASE}`.substring(0, 7)}
                            </div>
                        )}
                        {env.VITE_PRODUCT_RELEASE_TIME && (
                            <div className="text-xs text-white">Timestamp: {env.VITE_PRODUCT_RELEASE_TIME}</div>
                        )}
                    </div>
                </div>
            )}
            <DebugButton
                Icon={BugAntIcon}
                onClick={() => {
                    setOpen((open) => !open)
                }}
            />
        </>
    )
})
